(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cards-slider"] && !Shopify.designMode) return;
  try {
    
    const section = document.querySelector('.custom-cards-slider');

    const slidesPerView = parseFloat(section.dataset.swiperSlidesPerView) || 1;
    const slidesPerViewMobile = parseFloat(section.dataset.swiperSlidesPerViewMobile) || 1;
    const gap = parseInt(section.dataset.swiperGap) || 0;

    const swiper = new Swiper('.swiper', {
        direction: 'horizontal',
        loop: true,
        spaceBetween: gap,
        slidesPerView: slidesPerViewMobile,
        breakpoints: {
            768: {
            slidesPerView: slidesPerView,
            }
        }
    });

  } catch(e) { console.error(e); }
})();
})();
